import type { FC } from 'react';
import { ReportTable, type ReportTableProps } from './Table';
import {
  PDF_BORDER,
  SECTION_FONT_SIZE,
  SECTION_TITLE_BACKGROUND_COLOR,
} from './constants';

export type ReportSectionItemTableProps = Pick<
  ReportTableProps,
  'header' | 'data'
> & {
  tableWidth?: string;
};

export const ReportSectionItemTable: FC<ReportSectionItemTableProps> = ({
  header,
  data,
  tableWidth,
}) => {
  const styledHeader = header.map((headerItem, idx) => {
    const isLast = idx === header.length - 1;
    return {
      ...headerItem,
      textStyle: {
        fontSize: SECTION_FONT_SIZE,
        textAlign:
          headerItem.type === 'text' && headerItem.align
            ? headerItem.align
            : ('left' as const),
        ...(headerItem.type === 'text' ? { ...headerItem.textStyle } : {}),
      },
      wrapperStyle: {
        borderLeft: 'none',
        borderRight: isLast ? 'none' : PDF_BORDER.THIN,
        padding: '0 8px',
        ...headerItem.wrapperStyle,
      },
    };
  });

  const styledData = data.map((row, rowIdx) => {
    const isLastRow = rowIdx === data.length - 1;
    return {
      row: row.row.map((cell, cellIdx) => {
        const isLast = cellIdx === row.row.length - 1;
        return {
          ...cell,
          textStyle: {
            fontSize: SECTION_FONT_SIZE,
            textAlign:
              cell.type === 'text' && cell.align
                ? cell.align
                : ('left' as const),
            ...(cell.type === 'text' ? { ...cell.textStyle } : {}),
          },
          wrapperStyle: {
            borderLeft: 'none',
            borderRight: isLast ? 'none' : PDF_BORDER.THIN,
            padding: '0 8px',
            ...cell.wrapperStyle,
          },
        };
      }),
      rowStyle: {
        borderLeft: 'none',
        borderRight: 'none',
        borderBottom: isLastRow ? 'none' : PDF_BORDER.THIN,
        ...row.rowStyle,
      },
    };
  });

  return (
    <ReportTable
      header={styledHeader}
      data={styledData}
      tableWidth={tableWidth ?? '100%'}
      tableStyle={{
        border: 'none',
      }}
      headerStyle={{
        backgroundColor: SECTION_TITLE_BACKGROUND_COLOR,
        border: 'none',
      }}
    />
  );
};
